import { Space, Typography } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

/**
 * Every screen's header block: large title + secondary subtitle + right-side actions.
 * Keeps sizing and spacing consistent across the surface.
 */
export function PageHeader({ title, subtitle, actions }: Props) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, marginBottom: 12 }}>
      <div style={{ minWidth: 0 }}>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        {subtitle && (
          <Typography.Text type="secondary" style={{ fontSize: 12.5 }}>
            {subtitle}
          </Typography.Text>
        )}
      </div>
      {actions && <Space size={8}>{actions}</Space>}
    </div>
  );
}
